exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divFilter[data-v-0b703e3f]{position:absolute;left:0;width:300px;background-color:#e6f2fd;min-height:80px;z-index:9999;padding:5px;border-radius:5px;box-shadow:0 0 5px rgb(0 0 0/40%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b703e3f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListDocInfo/Components/FilterListDocInfo.vue
// module id = 535
// module chunks = 0